import React from 'react'

import CollapseContext from 'contexts/CollapseContext'

const CollapseProvider = ({ children }) => {
  const [data, setData] = React.useState([])

  return (
    <CollapseContext.Provider
      value={{
        data,
        setData,
      }}
    >
      {children}
    </CollapseContext.Provider>
  )
}

export default CollapseProvider
